/**
 * Mixin xử lý validate combobox
 */
import i18nValidate from '@/i18ns/vi/i18nValidate';
import { ModuleTARiskCustomerVendor, ModuleOrganizationHaveRisk } from '@/stores/moduleConst';
import { validateText } from './validateText';

export const validateCombobox = {
  /**
   * @override
   */
  validateRule(rule, editor, hasValidateSave, compareValue, customValidate) {
    const me = this;
    let res = true;
    let message = '';
    const titleError = editor.getTitleError();
    switch (rule) {
      case 'forceSelection':
        if (!me.validateForceSelection(editor)) {
          message = i18nValidate.messages[rule](titleError);
        }

        break;
      case 'notSelectParent':
        if (!me.validateNotSelectParent(editor)) {
          message = i18nValidate.messages[rule](titleError);
        }
        break;
      case 'required':
        const controlValue = editor.getValue();
        if (controlValue === undefined || controlValue === null || controlValue === NaN || controlValue === '') {
          message = i18nValidate.messages[rule](titleError);
        }
        break;
      case 'missingValue':
        let controlValueMisingValue = editor.getValue();
        if ((controlValueMisingValue === undefined || controlValueMisingValue === null || controlValueMisingValue === NaN || controlValueMisingValue === '') && hasValidateSave) {
          message = i18nValidate.messages[rule](titleError);
        }
        break;
      case 'tax':
        const controlValueCompanyTax = editor.getValue();
        if (!validateText.validateRule(compareValue, controlValueCompanyTax)) {
          message = i18nValidate.messages['taxCode'](titleError);
        }
        break;
      case 'business':
        const controlValueBusiness = editor.getValue();
        if(customValidate && typeof customValidate === 'function')
          message = customValidate(controlValueBusiness);
        break;
    }

    return message;
  },

  /**
   * Xử lý force selection
   * @param {*} editor
   * @returns
   * HTHIEP 01.07.2022: Sửa lại việc lấy item theo text => case thêm trường hợp có suffix
   */
  validateForceSelection(editor) {
    const me = this;
    if (editor && editor.internalText) {
      //nếu là binding trên grid
      if (editor.$cell && editor.queryMode === 'remote' && !editor.lastRequestParam) {
        return true;
      }

      let dataSource = editor.internalDataSource;

      //nếu là binding thì trả về true
      // pvduy 29/06/2021: sửa lỗi khi hủy form thêm mới trên combobox thì ko cảnh báo.
      if (
        editor.internalText === editor.initText &&
        dataSource.length === 0 &&
        (!me.forceSelection || me.internalValue)
      ) {
        return true;
      }

      if (dataSource && dataSource.length > 0) {
        if (editor.value) {
          return true;
        }
        let valueText = editor.internalText;
        let items = editor.isMultiple ? editor.findItemByArray() : editor.findItemByText(valueText);
        if (items && items.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  },
  /**
   * Validate cảnh báo rủi ro khách hàng, nhà cung cấp
   * @returns 
   * NBTIN 18.01.2024
   */
  validateRiskCustomerVendor(rule, editor) {
    var message = {};

    var notActiveTaxCustomerVendor = editor.$store.state[ModuleTARiskCustomerVendor].activeStatusNNTs?.find(x => x.taxCode == editor.internalSelectedItem?.company_tax_code);
    var riskCustomerVendor = editor.$store.state[ModuleOrganizationHaveRisk].items?.find(x => x.tax_code == editor.internalSelectedItem?.company_tax_code);

    if (notActiveTaxCustomerVendor && !riskCustomerVendor) {
      message.text = i18nValidate.messages[rule](editor.$ms.constant.RiskCustomerVendorType.NoneActivity);
      message.riskType = editor.$ms.constant.RiskCustomerVendorType.NoneActivity;
      message.closedDate = notActiveTaxCustomerVendor.closedDate;
    } else if (!notActiveTaxCustomerVendor && riskCustomerVendor) {
      message.text = i18nValidate.messages[rule](editor.$ms.constant.RiskCustomerVendorType.RiskInvoice);
      message.riskType = editor.$ms.constant.RiskCustomerVendorType.RiskInvoice;
      message.document_name = riskCustomerVendor.document_name;
    } else if (notActiveTaxCustomerVendor && riskCustomerVendor) {
      message.text = i18nValidate.messages[rule](editor.$ms.constant.RiskCustomerVendorType.NoneActivityAndRiskInvoce);
      message.riskType = editor.$ms.constant.RiskCustomerVendorType.NoneActivityAndRiskInvoce;
      message.document_name = riskCustomerVendor.document_name;
      message.closedDate = notActiveTaxCustomerVendor.closedDate;
    } else {
      message.text = i18nValidate.messages[rule](editor.$ms.constant.RiskCustomerVendorType.None);
      message.riskType = editor.$ms.constant.RiskCustomerVendorType.None;
    }
    message = JSON.stringify(message);
    return message;
  },

  /**
   * ĐVThi 05/02/2020: Validate bắt buộc chọn con, không được chọn cha
   */
  validateNotSelectParent(editor) {
    if (editor) {
      let item = editor.internalSelectedItem;
      if (item && item.isParent) {
        return false;
      }
    }
    return true;
  },
};
